module.exports = __webpack_public_path__ + "static/media/co2Icon.20520aeb.png";